export const priceNew = (price, sales) => {
  let new_price = price * ((100 - sales) / 100);
  return new_price;
};
